import { Link } from 'react-router-dom';
import './Nosotros.css';

const valores = [
  { icon: '🎯', title: 'Resultados concretos', desc: 'No vendemos tecnología por moda. Cada implementación tiene métricas claras y resultados medibles.' },
  { icon: '🤝', title: 'Cercanía regional', desc: 'Somos del Tolima. Conocemos el contexto, los actores y las necesidades del tejido empresarial e institucional local.' },
  { icon: '🔒', title: 'Confianza institucional', desc: 'Experiencia directa en gobierno digital y política pública TIC nos da credibilidad única en el sector público.' },
  { icon: '⚡', title: 'Innovación práctica', desc: 'Aplicamos las herramientas de IA más avanzadas del mundo al contexto real de las empresas colombianas.' },
];

export default function Nosotros() {
  return (
    <main className="nosotros-page">
      <section className="page-hero">
        <div className="page-hero__bg"><div className="page-hero__orb" /></div>
        <div className="container page-hero__content">
          <div className="tag">Nosotros</div>
          <h1 className="page-hero__title">IA con raíces<br /><span>en el Tolima</span></h1>
          <p className="page-hero__sub">Combinamos experiencia institucional, conocimiento técnico y vocación de servicio para llevar la inteligencia artificial al corazón de Colombia.</p>
        </div>
      </section>

      {/* FUNDADOR */}
      <section className="section">
        <div className="container">
          <div className="founder">
            <div className="founder__visual">
              <div className="founder__avatar">
                <span>CS</span>
              </div>
              <div className="founder__badge">
                <span>🏛️</span>
                <div>
                  <strong>Enlace Regional MinTIC</strong>
                  <span>Tolima, Colombia</span>
                </div>
              </div>
            </div>
            <div className="founder__content">
              <div className="tag">Fundador</div>
              <h2 className="section-title" style={{textAlign:'left'}}>Camilo Salazar Valbuena</h2>
              <p className="founder__role">Ingeniero de Sistemas · Especialista en Gestión TI</p>
              <p className="founder__bio">
                Con más de dos años de experiencia en tecnología e innovación pública, Camilo lideró la transformación digital de Alcaldías Municipales del Tolima y actuó como Apoyo Enlace Regional de MinTIC para el departamento, conectando la política pública nacional con las necesidades reales del territorio.
              </p>
              <p className="founder__bio">
                Esa trayectoria le otorga una perspectiva única: entiende tanto el lenguaje técnico de la IA como el lenguaje administrativo de las entidades públicas y el lenguaje práctico de las PyMEs. KAIROS AI nació de esa intersección.
              </p>
              <div className="founder__credentials">
                <div className="credential">
                  <span className="credential__icon">🎓</span>
                  <span>Ing. de Sistemas + Especialización en Gestión TI</span>
                </div>
                <div className="credential">
                  <span className="credential__icon">🏛️</span>
                  <span>Fue Apoyo Enlace Regional MinTIC · Departamento del Tolima</span>
                </div>
                <div className="credential">
                  <span className="credential__icon">💼</span>
                  <span>Líder TIC · Alcaldía Municipal del Tolima</span>
                </div>
                <div className="credential">
                  <span className="credential__icon">📍</span>
                  <span>Ibagué, Tolima · Colombia</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* VALORES */}
      <section className="section" style={{paddingTop:0}}>
        <div className="container">
          <div className="section-header">
            <div className="tag">Valores</div>
            <h2 className="section-title">Lo que nos mueve</h2>
          </div>
          <div className="valores-grid">
            {valores.map((v, i) => (
              <div className="valor-card" key={i}>
                <span className="valor-card__icon">{v.icon}</span>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MISIÓN / VISIÓN */}
      <section className="section" style={{paddingTop:0}}>
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card">
              <div className="tag">Misión</div>
              <p>Democratizar la inteligencia artificial para empresas e instituciones del Tolima y Colombia, haciendo que la tecnología más avanzada del mundo sea accesible, práctica y rentable para nuestra región.</p>
            </div>
            <div className="mv-card mv-card--vision">
              <div className="tag">Visión</div>
              <p>Ser la consultora de referencia en adopción de IA en Colombia, reconocida por transformar la productividad del sector público y privado con soluciones éticas, sostenibles y de impacto real.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-sm">
        <div className="container" style={{textAlign:'center'}}>
          <div className="tag">¿Trabajamos juntos?</div>
          <h2 style={{fontFamily:'var(--font-display)', fontSize:'clamp(24px,3.5vw,38px)', fontWeight:500, color:'var(--aire)', margin:'12px 0 16px'}}>Hablemos de tu proyecto</h2>
          <p style={{color:'var(--luz)', marginBottom:28}}>Agenda una llamada y cuéntanos cómo podemos ayudarte.</p>
          <Link to="/contacto" className="btn-primary">Agendar llamada →</Link>
        </div>
      </section>
    </main>
  );
}
